module.exports = __webpack_public_path__ + "static/media/wraps.fefc98c9.jpg";